// extracted by mini-css-extract-plugin
export default {"button":"RunningButton_button__WRN7S"};